




































































































































































































































































































































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Case } from '@/modules/Case/interfaces/case'
import { AccountCertificateType, AccountCertificate } from '@/modules/AccountCertificate/interfaces/account-certificate'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay, dateTimeToDisplay } from '@/utils/dateTime'
import AccountCertificateDialog from '@/modules/AccountCertificate/scripts/account-certificate-dialog'
import { getAccountCertificates } from '@/modules/Account/gql/account.gql'
import { showErrors } from '@/utils/snack'
import { CaseReview } from '@/modules/Newcase/interfaces/case-review'
import { accountAssetType } from '@/modules/AccountAsset/helpers/account-asset'

@Component({
  components: {
    CaseFoldingCard
  }
})
export default class AccountCertificates extends mixins(AccountCertificateDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Boolean, default: true }) readonly editable!: Boolean
  @Prop({ type: Boolean }) readonly unFolding!: boolean
  @Prop({ type: Object as () => CaseReview }) readonly review!: CaseReview

  certificates: AccountCertificate[] = []
  idCards: AccountCertificate[] = []
  ssn: AccountCertificate[] = []
  drivingLicenses: AccountCertificate[] = []
  ddc: AccountCertificate[] = []
  mvr: AccountCertificate[] = []
  other: AccountCertificate[] = []

  accountCertificateType = AccountCertificateType

  idCardTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'idNumber',
      title: 'Id Number',
      slots: { default: 'idNumber' },
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  ssnTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'ssn',
      title: 'SSN',
      slots: { default: 'ssn' },
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  drivingLicenseTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'licenseNumber',
      title: 'License Number',
      slots: { default: 'licenseNumber' },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  ddcTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  mvrTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      width: 400,
      resizable: true
    },
    { field: 'licenseNumber',
      title: 'License Number',
      slots: { default: 'licenseNumber' },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  otherTableColumn = [
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'legalName',
      title: 'Legal Name',
      slots: { default: 'legalName' },
      resizable: true
    },
    { field: 'idNumber',
      title: 'ID Number',
      slots: { default: 'idNumber' },
      width: 200,
      resizable: true
    },
    { field: 'ssn',
      title: 'SSN',
      slots: { default: 'ssn' },
      width: 200,
      resizable: true
    },
    { field: 'licenseNumber',
      title: 'License Number',
      slots: { default: 'licenseNumber' },
      resizable: true
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: 'expirationDate' },
      width: 200,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  dateToDisplay = dateToDisplay
  dateTimeToDisplay = dateTimeToDisplay
  dollarFilter = dollarFilter

  get accountId () {
    return +this.caseInfo.account.id
  }

  get certificateCardTitle () {
    return `Certificates (${this.certificates.length})`
  }

  mounted () {
    this.getAccountCertificates()
  }

  @Watch('caseInfo')
  onCaseInfoChanged (val: Case) {
    this.getAccountCertificates()
  }

  async getAccountCertificates () {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.query({
        query: getAccountCertificates,
        variables: {
          accountId: +this.caseInfo.account.id,
          filter: {}
        }
      })
      this.certificates = result.data.getAccountCertificates.accountCertificates
      this.idCards = []
      this.drivingLicenses = []
      this.ssn = []
      this.ddc = []
      this.mvr = []
      this.other = []
      for (const certificate of this.certificates) {
        switch (certificate.type) {
          case AccountCertificateType.ID_CARD:
            this.idCards.push(certificate)
            break
          case AccountCertificateType.DRIVING_LICENSE:
            this.drivingLicenses.push(certificate)
            break
          case AccountCertificateType.DDC:
            this.ddc.push(certificate)
            break
          case AccountCertificateType.SSN:
            this.ssn.push(certificate)
            break
          case AccountCertificateType.MVR:
            this.mvr.push(certificate)
            break
          case AccountCertificateType.OTHER:
            this.other.push(certificate)
            break
          default:
            break
        }
      }
      this.targetAccountCertificate = null
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  getLegalName (first: string, middle: string, last: string) {
    const name = first || ' ' + ' ' + middle || ' ' + ' ' + last || ' '
    if (name.trim() && name.trim() !== 'null') {
      return name.trim()
    }
    return '-'
  }

  newCertificate (e: Event, type: AccountCertificateType) {
    e.preventDefault()
    e.stopPropagation()

    this.targetAccountCertificate = {
      type,
      id: -1,
      ...this.targetAccountCertificate
    } as AccountCertificate
    this.showAccountCertificateEditDialog(e)
  }

  async deleteAccountCertificateConfirm () {
    if (!this.targetAccountCertificate) {
      return
    }
    await this.deleteAccountCertificatePost()
    this.getAccountCertificates()
  }
}
